import { digitDateWithDigitHourFormatter } from "../../components/tools";

export const ExpiredFormatter = (item) => {
  const { status_history, created_at } = item;

  const array = [
    {
      date: digitDateWithDigitHourFormatter(created_at),
      text: "You created a transaction",
      isActive: true,
    },
    {
      date: digitDateWithDigitHourFormatter(
        (status_history || [])[0]?.created_at
      ),
      text: "This transaction has been expired",
      isRedButton: true,
      isActive: true,
    },
  ];

  return array;
};
